import { Banner, Text } from '@betterment/samba-react';

export function PendingTransactionsBanner() {
  return (
    <Banner variant="info" css={{ width: '100%' }}>
      <Text>
        Please note, there are pending transactions in your client’s account that may delay trades and affect final
        execution price and quantity.
      </Text>
    </Banner>
  );
}
